import React from 'react';
import { Chart } from 'primereact/chart';

type SubscriptionData = {
    basic: number;
    professional: number;
    enterprise: number;
    totalOrganizations: number;
    monthlyRevenue: string;
    professionalPercentage: number;
};

type SubscriptionPlanChartProps = {
    data: SubscriptionData;
};

const SubscriptionPlanChart: React.FC<SubscriptionPlanChartProps> = ({ data }) => {
    const chartData = {
        labels: ['Basic', 'Professional', 'Enterprise'],
        datasets: [
            {
                data: [data.basic, data.professional, data.enterprise],
                backgroundColor: ['#0D47A1', '#1565C0', '#0D47A1'],
                borderRadius: 4,
                barThickness: 40,
                maxBarThickness: 60,
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (context: any) {
                        return `${context.label}: ${context.raw}`;
                    },
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.05)',
                },
                ticks: {
                    stepSize: 12,
                    font: {
                        size: 11,
                    },
                    color: '#666666',
                },
                min: 0,
                max: 36,
            },
            x: {
                grid: {
                    display: false,
                },
            },
        },
        maintainAspectRatio: false,
        barPercentage: 0.6,
        categoryPercentage: 0.7,
    };

    return (
        <div className="subscription-chart-card dashboard-card-wrapper coming-soon-card">
            <h2 className="chart-title">Organizations by Subscription Plan</h2>
            <div className="chart-container">
                <Chart type="bar" data={chartData} options={options} />
            </div>
            <div className="chart-stats">
                <div className="stat-box">
                    <span className="stat-value">{data.totalOrganizations}</span>
                    <span className="stat-label">Total Organizations</span>
                </div>
                <div className="stat-box">
                    <span className="stat-value">{data.monthlyRevenue}</span>
                    <span className="stat-label">Monthly Revenue</span>
                </div>
                <div className="stat-box">
                    <span className="stat-value">{data.professionalPercentage}%</span>
                    <span className="stat-label">Professional Plan</span>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionPlanChart;
